/**
 * The Assist card on a listing page (brief R14; board Listing.dc.html, Tweak
 * "Before registration (waitlist)"; screens listing-assist-waitlist.png and
 * listing-assist-waitlist-joined.png). Typographic apostrophes.
 *
 * Waitlist mode shows no paid service (R2): no fee, percentage, "commission",
 * "buyer agreement", "How Assist works", and no link to /assist, the request
 * sheet or a Purchase Room. The live card's copy arrives with ASSIST-04.
 */
export const cardCopy = {
  waitlist: {
    headlineLead: 'The seller has an agent.',
    headlineFollow: 'You should have one too.',
    body: 'Afriqahome Assist is coming: support for home buyers in Nairobi.',
    button: 'Register interest',
    footnote: 'No cost and no commitment.',
    joinedTitle: 'You’re on the list.',
    joinedBody: 'We’ll contact you when Assist is ready.',
  },
} as const;
